import { connect } from 'react-redux';
import ExcludedClinicians from './../../../components/Patients/Patient/ExcludedClinicians';
import { removeExcludedClinician, excludeClinician } from '../../../actions/entities';

const mapStateToProps = ({ entities: { patients } }) => ({
  patient: patients.previewed.patient,
});

const mapDispatchToProps = dispatch => ({
  excludeClinician: (patientId, clinicianId, reason) => dispatch(excludeClinician(patientId, clinicianId, reason)),
  removeExcludedClinician: (patientId, clinicianId) => dispatch(removeExcludedClinician(patientId, clinicianId)),
});

const ExcludedCliniciansContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExcludedClinicians);

export default ExcludedCliniciansContainer;
